import Hero from "./Hero";
import IntroSection from "./sections/IntroSection";
import NumbersSection from "./sections/NumbersSection";
import QuoteSection from "./sections/QuoteSection";
import InvestmentsSection from "./sections/InvestmentsSection";
import LegacySection from "./sections/LegacySection";
import BigFooter from "./sections/BigFooter";

export default function Home() {
  return (
    <main className="bg-black text-white">
      <Hero />
      {/* Everything below Hero lives on a higher stacking layer so it
          slides up on top of the fixed Hero as the user scrolls, instead of
          Hero itself moving. */}
      <div className="relative" style={{ zIndex: 10, background: "#000000" }}>
        <IntroSection />
        <NumbersSection />
        <QuoteSection />
        <InvestmentsSection />
        <LegacySection />
        <BigFooter />
      </div>
    </main>
  );
}